import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M19.233 4H4.764C3.238 4 2 5.228 2 6.74V20l4.558-2.964h12.678c1.526 0 2.764-1.228 2.764-2.74V6.74C22 5.228 20.762 4 19.233 4zm-4.627 9.386H5.591v-1.482h9.015v1.482zm3.8-4.254H5.591V7.65h12.815v1.482z" }));
export default createSvgIcon(iconPath, "Social");
//# sourceMappingURL=SocialIcon.js.map